import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../config/config";
import Header from "../../directives/header";
import Footer from "../../directives/footer";
import { IoLogoAndroid } from "react-icons/io";
import { FaApple } from "react-icons/fa";
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  Accordion,
  Image
} from "react-bootstrap";
import { Zoom, Fade, Slide } from "react-reveal";
// Import Swiper React components
import "../../directives/header.css";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
// import required modules
import "./css/home.css";
import { Toaster } from "react-hot-toast";
import Cookies from "js-cookie";
import { getFaqsAction } from "../../Action/user.action";
import HomeMetaTag from "./../MetaTags/HomeMetaTag";
// import Swal from "sweetalert2";

const Home = () => {
  const [show, setShow] = useState(true);
  const [faqsList, setFaqsList] = useState([]);

  useEffect(() => {
    getFaqs();
  }, [])

  const getFaqs = async () => {
    let res = await getFaqsAction();
    if (res.success) {
      setFaqsList(res.data);
    } else {
      setFaqsList([]);
    }
  }

  const handleClose = () => {
    setShow(false);
  };
 

  const handleShow = () => {
    setShow(true);
  };

  return (
    <>
      <Header />
      {/* <Helmet> */}
      <HomeMetaTag />
      <Toaster />
      <div className="lighttheme bg-white overflow-hidden">
        <section className="herobanner position-relative text-white overflow-hidden">
          <div className="banner_bg">
            <img alt=""
              src="assets/images/banner-before.png"
              className="bannerbefore"
            />
          </div>
          <Container>
            <Row className="align-items-center">
              <Col lg={6}>
                <Fade left>
                  <div className="bannerContent ">
                    <h1>MOVE TO EARN</h1>
                    <p className="mt-4">
                      A journey that’s going to make you Wealthier, Step by
                      Step! Stepmint is the first step for connecting your
                      Health with Wealth. Stepmint integrates fitness and Wealth
                      with real crypto rewards through Web 3.0 technology.
                    </p>
                  </div>
                </Fade>
              </Col>
              <Col lg={6} className="text-center">
                <Zoom>
                  <div className="bannerImage position-relative">
                    <img alt="" src='https://stepmintbucket.s3.ap-south-1.amazonaws.com/saina+nehwal.png' />
                  </div>
                </Zoom>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="ourmission bg-white pt-0">
          <Container className="bg-blue">
            <Row className="align-items-center p-5 gy-3">
              <Col lg={6} className=" position-relative">
                <Slide right>
                  <div className="stepmint-icon d-flex justify-content-center">
                    <img alt="" src="assets/images/stepmint-icon.png" />
                  </div>
                </Slide>
              </Col>
              <Col lg={6} className="">
                <Slide right>
                  <h4 className=" mb-4">
                    <b>OUR MISSION</b>
                  </h4>
                  <p>
                    Stepmint is a revolution meant to inspire individuals from
                    all walks of life to engage in physical activity.
                  </p>
                  <p>
                    Our mission? Well, it revolves around fostering a robust and
                    health-conscious community. We achieve this goal by
                    establishing a revolutionary crypto ecosystem, compelling
                    you to break free from your comfort zone. This will enhance
                    your overall health and grow your wallet simultaneously by
                    blending fitness and wealth-building. It's not just a
                    workout; it's a wealth-building exercise!
                  </p>
                  {/* <Button
                    variant="main2"
                    onClick={navigateToPackagePlan}
                    className="text-white px-5 mt-3"
                  >
                    Subscribe
                  </Button> */}
                </Slide>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="weightloss bg-gradient position-relative mt-5">
          <Container>
            <Row>
              <Col lg={7} className="">
                <Zoom>
                  <div className="weight-content text-white pt-4">
                    <div className="mb-3">
                      <h4
                        className="text-white text-uppercase"
                        style={{ fontWeight: "600" }}
                      >
                        Benefits Of 10,000 Steps Per Day With Stepmint
                      </h4>
                    </div>
                    <div className="">
                      <div className="list px-0">
                        <Row>
                          <Col lg={12}>
                            <ul className="pl-0">
                              <li className="d-flex align-items-center">Health Oasis: No sick days ahead!</li>
                              <li className="d-flex align-items-center">Your ticket to a happy mind.</li>
                              <li className="d-flex align-items-center">Revitalize your day with a power surge!</li>
                              <li className="d-flex align-items-center">Strong immunity and better sleep.</li>
                              <li className="d-flex align-items-center">
                                Your passport to an injury-free, vibrant life.
                              </li>
                              <li className="d-flex align-items-center">31% lower mortality risk.</li>
                              <li className="d-flex align-items-center">
                                Stressed? Let every step be your stress
                                vanisher!
                              </li>
                              <li className="d-flex align-items-center">Shedding weight, one step at a time!</li>
                            </ul>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </Zoom>
              </Col>
              <Col lg={5}>
                <div className="weightloss-img">
                  <img alt="" src="assets/images/woman-stretching-leg.png" />
                </div>
              </Col>
            </Row>
          </Container>
          <div className="leftstar">
            <img alt="" src="assets/images/leftstar.png" />
          </div>
        </section>
        <section className="bg-white sport_community">
          <Container>
            <Row className="align-items-center mt-4 mb-4">
              <Col lg={6} className="">
                <Zoom>
                  <div className="sport-community-content">
                    <h4 >
                      <b>Building A Diverse Community</b>
                    </h4>
                    <p className="mb-0">
                      Connect with like-minded individuals, tackle daily tasks,
                      and participate in exhilarating trekking events,
                      marathons, and treasure hunts, enabling you to reap
                      fantastic rewards along the way.
                    </p>
                  </div>
                </Zoom>
              </Col>
              <Col lg={6} className="text-right">
                <Fade right>
                  <img alt="" src="assets/images/sportcommunity.png" />
                </Fade>
              </Col>
            </Row>
            <Row className="align-items-center mt-4 mb-4">
              <Col lg={6} className="text-left">
                <Fade right>
                  <img alt="" src="assets/images/health_consultant.png" />
                </Fade>
              </Col>
              <Col lg={6} className="">
                <Zoom>
                  <div className="sport-community-content">
                    <h4>
                      <b>Health Consultation and Data Security</b>
                    </h4>
                    <p className="mb-0">
                      Stepmint revolutionizes fitness with personalized
                      consultations from doctors and trainers. Whether you aim
                      for weight loss, muscle gain, or holistic wellness, our
                      platform empowers you to achieve your goals. Since your
                      health data is priceless, Stepmint prioritizes its
                      security through Web 3.0 Cosmos, ensuring safe and
                      accessible health records.
                    </p>
                  </div>
                </Zoom>
              </Col>
            </Row>
            <Row className="align-items-center mt-4 mb-4">
              <Col lg={6} className="">
                <Zoom>
                  <div className="sport-community-content">
                    <h4>
                      <b>Health with Wealth</b>
                    </h4>
                    <p className="">
                      Wealth opens the doors to a comfy life, education, and
                      personal growth. It's the ticket to security, travel, and
                      pursuing passions. Health, the bedrock of a fulfilling
                      life, lets you relish every moment, chase goals, and build
                      meaningful connections. Striking a balance is a must.
                      Focusing solely on wealth invites stress; neglecting
                      health means limited access to care and comfort.
                      Prioritize health with exercise and wellness. Balancing
                      both is the safe spot, where health enriches wealth
                      benefits, and wealth fuels a healthy lifestyle. It's the
                      ideal path to a vibrant life! With Stepmint you follow
                      this ideal path to a grand lifestyle.
                    </p>
                  </div>
                </Zoom>
              </Col>
              <Col lg={6} className="text-right">
                <Fade right>
                  <img alt="" src="assets/images/health_versus.png" />
                </Fade>
              </Col>
            </Row>
          </Container>
        </section>

        <div className="homepage2">
          <section className="faq pt-0">
            <Container>
              <Row>
                <Col lg={12}>
                  <div className="">
                    <div className="side_bg">
                      <img alt="" src="assets/home_assets/images/side_bg.png" />
                    </div>
                    <Container className="position-relative">
                      <Row className="justify-content-center align-items-center">
                        <Col lg={6}>
                          <div className="text-center position-relative">
                            <h2 className="subheading text-uppercase faq-heading">
                              FAQ
                            </h2>
                            <img alt=""
                              src="assets/home_assets/images/run_man.png"
                              height="701px"
                              style={{ ObjectFit: "contain" }}
                              className="runman"
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="faq-list">
                            <Accordion defaultActiveKey={[0]} flush>
                              {faqsList.map((faq, index) => {
                                return (


                                  <Accordion.Item key={index} eventKey={index} style={{ border: "none" }}>
                                    <Accordion.Header style={{ border: "none" }}>
                                      {faq.question}
                                    </Accordion.Header>
                                    <Accordion.Body style={{ backgroundColor: "#f8f8f8", borderRadius: "0px 0px 10px 10px", fontSize: "small" }}>
                                      {faq.answer}
                                    </Accordion.Body>
                                  </Accordion.Item>
                                )
                              })}
                            </Accordion>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="position-relative pt-0">
            <div className="appdownload mobilehide">
              <img alt="" src="assets/home_assets/images/app_download.png" />
            </div>
            <div className="app_side side_bg mobileshow">
              <img alt="" src="assets/home_assets/images/side_bg.png" />
            </div>

            <Container>
              <Row>
                <Col lg={12}>
                  <div className="">
                    <Container className="position-relative">
                      <Row className="justify-content-center align-items-center">
                        <Col lg={4}>
                          <div>
                            <img alt="" src="assets/home_assets/images/phone.png" />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mt-5 pt-5">
                            <h1 className="wait_is_over">Grab the App Today!</h1>
                            <div className="storebtn mt-4">
                              <div className="mb-3">
                                <button className="btn btn-default border bg-white text-left">
                                  <a
                                    href="https://play.google.com/store/apps/details?id=com.espsofttech.stepmint"
                                    target="_blank"
                                    className="text-decoration-none "
                                    style={{ color: "#212529" }}
                                  >
                                    <div className="d-flex">
                                      <div>
                                        <img alt="" src="assets/home_assets/images/googleplay.png" />
                                      </div>

                                      <div className="text-left">
                                        <small>Get it On</small>
                                        <div>
                                          <span className="fw-bold">
                                            Google Play
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </a>
                                </button>
                              </div>
                              <div>
                                <button className="btn btn-default border bg-white text-left">
                                  <div className="d-flex">
                                    <div className="">
                                      <img alt="" src="assets/home_assets/images/apple.png" />
                                    </div>
                                    <div className="text-left">
                                      <a
                                        href="https://apps.apple.com/in/app/step-mint/id6473780792"
                                        target="_blank"
                                        className="text-decoration-none "
                                        style={{ color: "#212529" }}
                                      >
                                        <small>Get it On</small>
                                        <div>
                                          <span className="fw-bold">
                                            App Store
                                          </span>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                </button>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col lg={5}>
                          <div className="family">
                            <img alt="" src="assets/home_assets/images/family.png" />
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      </div>

      <Modal
        show={false}
        onHide={handleClose}
        backdrop="static"
        className="Nftmodal"
        size="lg"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="btn-rounded p-0"><a href={`${config.baseUrl}`} style={{ textDecoration: "none" }} className="d-flex flex-column justify-content-center">
          <Image className="rounded" src="assets/images/alertpopup2.jpg" fluid />
          <p className="text-center mt-3" >  In the meantime, you can get the APK from our Telegram group - <a href="https://t.me/stepmintcommunity" target="_blank">@stepmintcommunity</a></p>
          <p className="text-center mb-3"> Download App Now </p>
          <div className="text-center mb-3"><a href="https://stepmint.io/app/app-release.apk"
            target="_blank"
            style={{ textDecoration: "none" }}
            variant=""
            className="text-white px-4 py-2 ms-2 main2"
          >
            <IoLogoAndroid style={{ width: 20, height: 20 }} /> Android
          </a>
            <a href="https://apps.apple.com/in/app/step-mint/id6473780792"
              style={{ textDecoration: "none" }}
              target="_blank"
              variant=""
              className="text-white px-4 py-2 ms-2 main2"
            >
              <FaApple style={{ width: 20, height: 20 }} /> IOS
            </a>


          </div>


        </a>
        </Modal.Body>
      </Modal>

      <Footer />
    </>
  );
};
export default Home;
